import type { FC } from 'react'
import { scoreColor } from '../domain/Bet.domain'

interface Props {
  score: number
  size?: number
}

export const ScoreIndicator: FC<Props> = ({ score, size = 18 }) => {
  const label = score >= 4 ? 'Green' : score >= 3 ? 'Yellow' : 'Red'
  return (
    <div
      title={`Score: ${score.toFixed(1)} — ${label}`}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: scoreColor(score),
        flexShrink: 0,
        border: `2px solid ${scoreColor(score)}33`,
      }}
    />
  )
}
